import FileSaver from 'file-saver';

export function saveAs(blob: Blob, fileName: string): void {
  FileSaver.saveAs(blob, fileName);
}
